export default class InitializeProposalStateError extends Error {
    
}
